import * as React from "react";
import "./reconciliationModal.scss"
import CurrencyHelper from "../../../../../helper/CurrencyHelper";

interface IProps {
	due: number;
}

export const AmountToReconcile: React.SFC<IProps> = (props) => {
	return (
		<div className="c-reconciliation-modal_amount-to-reconcile">
			<div className="c-reconciliation-modal_amount-to-reconcile_label">Amount to reconcile</div>
			{!props.due &&
			<img className="c-reconciliation-modal_amount-to-reconcile_image" src="/assets/img/icons/icn-success-cmn.svg"/>}
			<div className="c-reconciliation-modal_amount-to-reconcile_amount">
				{CurrencyHelper.toCurrency(props.due)}
			</div>
			<div className="c-reconciliation-modal_amount-to-reconcile_horizontal-line"/>
			<div className="c-reconciliation-modal_amount-to-reconcile_horizontal-line"/>
		</div>
	);
};
